import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private pending = 0;
  readonly isLoading = signal<boolean>(false);

  show(): void {
    this.pending++;
    queueMicrotask(() => this.isLoading.set(true));
  }

  hide(): void {
    this.pending = Math.max(0, this.pending - 1);
    if (this.pending === 0) queueMicrotask(() => this.isLoading.set(false));
  }
}
